import { outlookTypes } from 'shared/constants/outlookTypes';

export const setRatingColor = outlook => {
  switch (outlook) {
    case outlookTypes.STABLE:
      return 'primary';
    case outlookTypes.NEGATIVE:
      return 'secondary';
    default:
      return 'default';
  }
};
